import { useEffect } from "react"
import { getBills } from "services/state/actions"

export const useBills = () => (dispatch, getState) => {
  useEffect(() => {
    getBills()(dispatch, getState)
  }, [])
}



// WEBPACK FOOTER //
// ./src/hooks/useBills.js